<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader style="padding:10px;">
        <student-header [pageTitle]="'Academic History'" [showYearSelector]="false">
            <div style="margin-left:400px;">
                <table style="color: #939393">
                    <tr *ngIf="academicHistorySummary.UnWeightedGPA > 0">
                        <td style="padding-left:5px; padding-right:30px;" translate>Unweighted GPA:</td>
                        <td class="text-left">&nbsp;{{academicHistorySummary.UnWeightedGPA}}</td>
                    </tr>
                    <tr *ngIf="academicHistorySummary.WeightedGPA > 0">
                        <td style="padding-left:5px; padding-right:30px;" translate>Weighted GPA:</td>
                        <td class="text-left">&nbsp;{{academicHistorySummary.WeightedGPA}}</td>
                    </tr>
                    <tr *ngIf="academicHistorySummary.ClassRankIn > 0 && academicHistorySummary.V9Flag == false && (userType == 1 || academicHistorySummary.S360ClassRank)" >
                        <td style="padding-left:5px; padding-right:30px;" translate>Class Rank:</td>
                        <td class="text-left">&nbsp;{{academicHistorySummary.ClassRankIn}}<span translate>&nbsp;out&nbsp;of&nbsp;</span>{{academicHistorySummary.ClassRankOut}}</td>
                    </tr>
                    <tr *ngIf="academicHistorySummary.ClassRankIn > 0 && academicHistorySummary.V9Flag == false && (userType == 1 || academicHistorySummary.S360ClassRank)" >
                        <td style="padding-left:5px; padding-right:30px;" translate>Rank Calculated:</td>
                        <td class="text-left">&nbsp;{{getFormattedDate(academicHistorySummary.RankCalculatedOn)}}</td>
                    </tr>
                </table>
            </div>
        </student-header>
    </div>
    <div class="flex-content">    
        <div style="text-align:center;" *ngIf="academicHistory.length == 0 && isShowHSTranscript==false && isBusy==false" translate>No Academic History data exists for student.</div>
        <div style="text-align:center;" *ngIf="academicHistory.length == 0 && isShowHSTranscript==true && isBusy==false" translate>No HS Transcript data exists for this student.</div>
        <div style="height:100%;" *ngIf="academicHistory.length > 0">
            <!-- Angular Material table definition -->
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear 
                    matSort id="AHdataTable"  matSortActive="AcademicYear" matSortDirection="desc" aria-label="Academic History Table" tabindex="0">
                <!-- Individual column definitions -->
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" class="print-ignore"><span translate>More</span></mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:68px;max-width:68px;text-align:center;" class="print-ignore">
                        <span aria-label="Expand row for more details" >
                                <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" aria-hidden="true"></i>
                        </span>
                    </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="AcademicYear">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:110px;max-width:110px;margin-right:10px;">
                        <span translate>Academic Year</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="AcademicYear" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:110px;max-width:110px;margin-right:10px;">{{AH.AcademicYear}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="School">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:135px;margin-right:10px;">
                        <span translate>School</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="School" dataType="string" #filter></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:135px;margin-right:10px;">{{AH.School}}</mat-cell>  
                </ng-container>            
                <ng-container matColumnDef="Gradelevel">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px;max-width:80px;margin-right:10px;">
                        <span translate>Grade Level</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="Gradelevel" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:80px;max-width:80px;margin-right:10px;">{{AH.Gradelevel}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="Course">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;margin-right:10px;">
                        <span translate>Course Name</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="Course" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:150px;margin-right:10px;">{{AH.Course}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="AttemptedCredit">                
                    <mat-header-cell *matHeaderCellDef mat-sort-header  style="min-width:115px;max-width:115px;margin-right:10px;">
                        <span translate>Attempted Credits</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="AttemptedCredit" dataType="number"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:110px;max-width:110px;margin-right:10px;">{{AH.AttemptedCredit}}</mat-cell>  
                </ng-container>            
                <ng-container matColumnDef="EarnedCredit">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;max-width:90px;margin-right:10px;">
                        <span translate>Earned Credits</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="EarnedCredit" dataType="number"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:90px;max-width:90px;margin-right:10px;">{{AH.EarnedCredit}}</mat-cell>  
                </ng-container>         
                <ng-container *ngFor="let sem of semesters; let i = index;" [matColumnDef]="sem" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header="Sem{{i}}" style="min-width:60px;max-width:100px;">S{{i+1}}
                            <!-- filtering does not currently work with dynamic columns -->
                            <!-- <filter class="mat-filter" [data]="angularMatData" columnName="AHSemester" index="{{i}}" dataType="string"></filter> -->
                        </mat-header-cell>
                        <mat-cell *matCellDef="let AH" style="min-width:60px;max-width:100px;">
                            <ng-container *ngFor="let ahSem of AH.AHSemester">
                                <span *ngIf="ahSem.Description == 'S' + (i + 1) || ahSem.TermIdentifier == 'S' + (i + 1)">{{ahSem.Grade}}</span>  
                            </ng-container>
                        </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="Final">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:75px;max-width:100px;margin-right:10px;">
                        <span translate>Final</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="Final" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AH" style="min-width:75px;max-width:100px;margin-right:10px;">{{AH.Final}}</mat-cell>  
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <!-- Detail row can have standard html or another Angular Material table -->
                    <td mat-cell *matCellDef="let AH" [attr.colspan]="columnsToDisplay.length"
                            style="width:100%;" class="mat-detail-card">
                        <div style="width:100%;">
                            <table style="width:100%;" aria-label="Academic History Details Table" tabindex="-1">
                                <tr style="line-height:normal;" tabindex="-1">
                                    <td style="color:#595959;width:125px;" translate role="columnheader">Course-Section</td>
                                    <td style="width:300px;" role="gridcell">{{AH.Subject}}<span *ngIf="AH.Section != undefined">-</span>{{AH.Section}}</td>
                                    <td style="color:#595959;width:125px;" role="columnheader"><span *ngIf="V10" translate>Include In GPA</span></td>
                                    <td><span *ngIf="V10" role="gridcell">{{AH.IncludeInGPA | yesNo}}</span></td>
                                </tr>
                                <tr style="line-height:normal;" tabindex="-1">
                                    <td style="color:#595959;width:125px;" translate role="columnheader">Teacher</td>
                                    <td style="width:300px;" role="gridcell">{{AH.Teacher}}</td>
                                    <td style="color:#595959;width:125px;" role="columnheader"><span *ngIf="AH.TransferredFrom != ''" translate>Transferred From</span></td>
                                    <td><span ng-show="AH.TransferredFrom != ''" role="gridcell">{{AH.TransferredFrom}}</span></td>
                                </tr>
                                <tr style="line-height:normal;" [hidden]="!V10" tabindex="-1">
                                    <td style="color:#595959;width:125px;" translate role="columnheader">Course Complete</td>
                                    <td style="width:300px;" role="gridcell">{{AH.CourseComplete | yesNo}}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </ng-container>
        
                <!-- Row definitions determine what will actually be displayed -->
                <!-- Styles set here will apply to all cells in the row -->
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id = "AHdataHeader" style="min-width: 1000px;">            
                </mat-header-row>   
                <!-- Data rows -->
                <mat-row    *matRowDef="let row; columns: columnsToDisplay; let i = index;" 
                            id = "AHdataRow{{i}}"
                            tabindex="0"
                            [attr.aria-label]="getAriaRow(row)"
                            [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}" 
                            style="padding:0px;overflow: hidden;min-width: 1000px;"
                            matRipple
                            (click)="toggleExpanded(row)"
                            (keydown)="rowKeyPress($event, row)">
                </mat-row>
                <!-- Detail row -->
                <!-- 'overflow: hidden' is required for animation to render properly -->
                <mat-row *matRowDef="let row; columns: ['expandedDetail']" 
                        [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"
                        style="overflow: hidden;min-width: 1000px;" class="mat-detail-row">
                </mat-row>
            </mat-table>
        </div>    
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">         
    <div class="flex-footer-left">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)" style="padding-left: 10px;"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
	<div class="flex-footer-middle" style="align-items: center">
		<filter-notification [filtered]="angularMatData.isFiltered()"
			(clearFilter)="angularMatData.removeAllFilters(); cdRef.detectChanges();"></filter-notification>
	</div>
    <div class="flex-footer-right">
        <mat-checkbox id="checkboxShowHSTran" style="display: flex; flex-direction: column; justify-content: center; padding-right: 20px;"
                [(ngModel)]="isShowHSTranscript" (click)="getAcademicHistory()"><span translate>Show HS Transcript Only</span></mat-checkbox>
    </div>
</div>
